import { Controller } from '@nestjs/common';

@Controller('relations')
export class RelationsController {}
